exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uk-card[data-v-2324c52c] {\n  color: black;\n  background-color: #ddd !important;\n  padding: 40px;\n  padding-bottom: 35px;\n  font-size: 1.2em;\n  border-radius: 6px;\n}", ""]);

// exports
